var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_55725",
    "data-name": "Group 55725",
    transform: "translate(-11066 -10540)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-phone-portrait",
    "data-name": "Icon ionic-ios-phone-portrait",
    d: "M19.967,2.25H11.824a1.689,1.689,0,0,0-1.7,1.689V23.5a1.739,1.739,0,0,0,1.7,1.751h8.137A1.7,1.7,0,0,0,21.62,23.5V3.939A1.647,1.647,0,0,0,19.967,2.25ZM15.1,3.431h1.54a.205.205,0,0,1,0,.411H15.1a.205.205,0,1,1,0-.411Zm.8,21.049a.893.893,0,1,1,.893-.893A.894.894,0,0,1,15.9,24.48Zm4.8-2.516H11.049a.1.1,0,0,1-.1-.1V4.971a.1.1,0,0,1,.1-.1H20.7a.1.1,0,0,1,.1.1V21.861A.1.1,0,0,1,20.7,21.964Z",
    transform: "translate(11062.999 10538.75)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14842",
    "data-name": "Rectangle 14842",
    width: 26,
    height: 26,
    transform: "translate(11066 10540)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileIcon);
export default __webpack_public_path__ + "static/media/MobileIcon.7bf9de28ec866bf1b3e373a12baa668e.svg";
export { ForwardRef as ReactComponent };